import script from "./CodeDisplay.vue?vue&type=script&lang=ts&setup=true"
export * from "./CodeDisplay.vue?vue&type=script&lang=ts&setup=true"

import "./CodeDisplay.vue?vue&type=style&index=0&id=5157f201&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5157f201"]])

export default __exports__